// extracted by mini-css-extract-plugin
export default {"linkButton":"LinkButton-module__linkButton__JN9f0Tw"};